import styled from 'styled-components';
import { H2Text, NormalSpan } from 'pages/charterQuote/components/contents/Content.style';

const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding-bottom: 48px;
  border-bottom: 1px solid #dde2e4;
`;

const HeaderDesc = styled.div`
  max-width: 572px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 16px;
  @media (min-width: 768px) and (max-width: 1280px) {
    max-width: 400px;
  }
`;

const Desc = styled(NormalSpan)`
  color: #424748;
`;
const Header = ({ title, desc }) => {
  return (
    <HeaderContainer>
      <H2Text>{title}</H2Text>
      <HeaderDesc>{desc && desc.map((text, index) => <Desc key={index}>{text}</Desc>)}</HeaderDesc>
    </HeaderContainer>
  );
};

export default Header;
